'use client';

import { useEffect } from 'react';
import { useParams } from 'next/navigation';

import { useModuleStore } from '@entities/module';

import { getLessonApi } from '../api/lesson.api';
import { generateModuleWithLessonTOC } from '../lib/toc';
import { useLessonStore } from '../model/store';

export const useActiveLesson = () => {
  const { moduleId } = useParams<{ moduleId: string }>();

  const activeModule = useModuleStore((state) => state.module);
  const lessonId = useLessonStore((state) => state.lessonId);
  const setLessonId = useLessonStore((state) => state.setLessonId);
  const setLesson = useLessonStore((state) => state.setLesson);
  const setSectionId = useLessonStore((state) => state.setSectionId);
  const setTOC = useLessonStore((state) => state.setTOC);
  const setNotes = useLessonStore((state) => state.setNotes);

  useEffect(() => {
    if (!moduleId) {
      setLessonId(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleId]);

  useEffect(() => {
    if (!lessonId) {
      const toc = activeModule ? generateModuleWithLessonTOC(activeModule) : [];

      setLesson(undefined);
      setSectionId(undefined);
      setTOC(toc);
      setNotes([]);
    } else {
      getLessonApi({ id: lessonId }).then((data) => {
        const toc = activeModule ? generateModuleWithLessonTOC(activeModule, data) : [];

        setLesson(data);
        setSectionId(
          data.sections?.find((section) => !section.locked)?.id || data.sections?.[0]?.id,
        );
        setTOC(toc);
        setNotes(data.notes);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessonId]);
};
